import React from "react";
import { Container, Base, Error, Title, Input, Button, Link, Text, TextSmall } from "./style/form";

function Form({children, ...restProps}) {
    return ( 
        <Container {...restProps}>{children}</Container>
     );
}

Form.Base = function FormBase({ children, ...restProps }){
    return <Base {...restProps}>{children}</Base>
}

Form.Error = function FormError({ children, ...restProps }){
    return <Error {...restProps}>{children}</Error>
}

Form.Title = function FormTitle({ children, ...restProps }){
    return <Title {...restProps}>{children}</Title>
}

Form.Input = function FormInput({ children, ...restProps }){
    return <Input {...restProps}>{children}</Input>
}

Form.Button = function FormButton({ children, ...restProps }){
    return <Button {...restProps}>{children}</Button>
}

Form.Link = function FormLink({ children, ...restProps }){
    return <Link {...restProps}>{children}</Link>
}

Form.Text = function FormText({ children, ...restProps }){
    return <Text {...restProps}>{children}</Text>
}

Form.TextSmall = function FormTextSmall({ children, ...restProps }){
    return <TextSmall {...restProps}>{children}</TextSmall>
}

export default Form;